/* Utils
--------------------------------------------- */

const API_URL = "/wp-content/themes/credum/ajax-calls.php";
const EMAIL_REGEX =
  /[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/;
const PHONE_REGEX = /^\d{6,12}$/;
const SSN_REGEX = /^([0-9xyzXYZ])([0-9]{7,7})([a-zA-Z])$/;
const POST_CODE_REGEX = /^\d{5}$/;
const Y_TUNNUS_REGEX = /^[a-zA-Z]{1}\d/;
const YYYY_MM_DD_REGEX =
  /^\d{4}\-(0[1-9]|1[012])\-(0[1-9]|[12][0-9]|3[01])$/;

const getHashedValue = async (value) => {
  try {
    const res = await (
      await fetch(API_URL, {
        method: "POST",
        body: JSON.stringify({
          ptvth: 1,
          value,
        }),
      })
    ).json();

    if (typeof res !== "object" || !res?.success || !res?.hashed) {
      throw new Error("Invalid getHashedValue response: " + JSON.stringify(res));
    }

    return res.hashed;
  } catch (err) {
    logJSError({
      err,
      description: "getHashedValue",
    });
    return null;
  }
};

const getRedirectUrl = async ({
  preApplicationId = ""
}) => {
  const d = getDomain();

  if (d === "credum.ph") {
    let url = `/most-popular-services-right-now/`;
    if (preApplicationId) {
      url += `?paId=${preApplicationId}`;
      url += `&pa_id=${preApplicationId}`;
      url += `&paid=${preApplicationId}`;
    }
    return url;
  }

  if ((d === "credum.co" || d === "credum.mx")) {
    let url = `/servicios-mas-populares-en-este-momento/`;
    if (preApplicationId) {
      url += `?paId=${preApplicationId}`;
      url += `&pa_id=${preApplicationId}`;
      url += `&paid=${preApplicationId}`;
    }
    return url;
  }

  if (d === "credum.pl") {
    let url = `/twoje-rekomendacje-credum/`;
    if (preApplicationId) {
      url += `?paId=${preApplicationId}`;
      url += `&pa_id=${preApplicationId}`;
      url += `&paid=${preApplicationId}`;
    }
    return url;
  }

  if (d === "credum.ro") {
    let url = `/cele-mai-populare-servicii-acum/`;
    if (preApplicationId) {
      url += `?paId=${preApplicationId}`;
      url += `&pa_id=${preApplicationId}`;
      url += `&paid=${preApplicationId}`;
    }
    return url;
  }

  if (d === "crediteus.dk") {
    let url = "/serviceanbefalinger/";
    if (preApplicationId) {
      url += `?paId=${preApplicationId}`;
      url += `&pa_id=${preApplicationId}`;
      url += `&paid=${preApplicationId}`;
    }
    return url;
  }

  if (d === "credum.kz") {
    let url = "/rezultaty/";
    if (preApplicationId) {
      url += `?paId=${preApplicationId}`;
      url += `&pa_id=${preApplicationId}`;
      url += `&paid=${preApplicationId}`;
    }
    return url;
  }

  alert("Server error");
  return "";
};

function getCurrentTimeAsDateTime() {
  const dt = new Date();

  const result =
    dt.toISOString().substring(0, 4) +
    "-" +
    dt.toISOString().substring(5, 7) +
    "-" +
    dt.toISOString().substring(8, 10) +
    " " +
    dt.toTimeString().substring(0, 8);

  return result; // YYYY-MM-DD HH:MM:SS, e.g. 2021-02-01 12:00:00
}

const getDomain = () => {
  let domain = window.location.hostname;
  domain = domain.replace("www.", "");
  domain = domain.replace("new.", "");
  return domain;
};

function setCookie(name, value, days = 60, domain = "credum.ph") {
  let expires = "";
  if (days) {
    const date = new Date();
    date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
    expires = "; expires=" + date.toUTCString();
  }
  let cookieString = name + "=" + (value || "") + expires + "; path=/";
  if (domain) {
    cookieString += "; domain=." + domain;
  }
  document.cookie = cookieString;
}

function getCookie(name) {
  const nameEQ = name + "=";
  const ca = document.cookie.split(';');
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) === ' ') c = c.substring(1, c.length);
    if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
  }
  return null;
}

function removeCookie(name) {
  document.cookie = name + '=; Max-Age=-99999999;';
}

const setIdentifier = async ({
  identifier,
  value,
}) => {
  try {
    setCookie(
      identifier,
      value,
      90,
      `.${getDomain()}`
    )
  } catch (err) {
    logJSError({
      err,
      description: "setIdentifier -> cookies",
    });
  }

  try {
    window.localStorage.setItem(identifier, value);
  } catch (err) {
    // Don't log as it seems this causes a wild number of errors in user_errors if someone blocks localStorage
    // logJSError({
    //   err,
    //   description: "setIdentifier -> localStorage",
    // });
  }

  try {
    window.sessionStorage.setItem;
  } catch (err) {
    // Don't log as it seems this causes a wild number of errors in user_errors if someone blocks sessionStorage
    // logJSError({
    //   err,
    //   description: "setIdentifier -> sessionStorage",
    // });
  }

  try {
    window[identifier] = value;
  } catch (err) {
    logJSError({
      err,
      description: "setIdentifier -> window",
    });
  }
};

const getIdentifier = async (
  identifier
) => {
  try {
    const cookieRes = getCookie(identifier);
    if (cookieRes) {
      return cookieRes;
    }
  } catch (err) {
    logJSError({
      err,
      description: "getIdentifier -> cookies",
    });
  }

  try {
    const localStorageRes = window.localStorage.getItem(identifier);
    if (localStorageRes) {
      return localStorageRes;
    }
  } catch (err) {
    logJSError({
      err,
      description: "getIdentifier -> localStorage",
    });
  }

  try {
    const sessionStorageRes = window.sessionStorage.getItem(
      identifier
    );
    if (sessionStorageRes) {
      return sessionStorageRes;
    }
  } catch (err) {
    logJSError({
      err,
      description: "getIdentifier -> sessionStorage",
    });
  }

  try {
    const windowRes = window[identifier];
    if (windowRes) {
      return windowRes;
    }
  } catch (err) {
    logJSError({
      err,
      description: "getIdentifier -> window",
    });
  }

  return null;
};

const removeIdentifier = async (identifier) => {
  try {
    Cookies.remove(identifier);
  } catch (err) {
    logJSError({
      err,
      description: "removeIdentifier -> cookies",
    });
  }

  try {
    window.localStorage.removeItem(identifier);
  } catch (err) {
    logJSError({
      err,
      description: "removeIdentifier -> localStorage",
    });
  }

  try {
    window.sessionStorage.removeItem(identifier);
  } catch (err) {
    logJSError({
      err,
      description: "removeIdentifier -> sessionStorage",
    });
  }

  try {
    delete window[identifier];
  } catch (err) {
    logJSError({
      err,
      description: "removeIdentifier -> window",
    });
  }
};

const isFreshLead = async ({ email, phone }) => {
  try {
    const isFreshLeadResponse = await (
      await fetch(API_URL, {
        method: "POST",
        body: JSON.stringify({
          ifl: 1,
          email,
          phone,
        }),
      })
    ).json();

    if (isFreshLeadResponse && isFreshLeadResponse.isFreshLead === true) {
      return true;
    }

    return false;
  } catch (err) {
    logJSError({
      err,
      description: "isFreshLead",
    });
    return false;
  }
};

const pushToDataLayer = async ({
  category = "application",
  action,
  label,
  value = 0,
  extraParams = {},
}) => {
  try {
    window.dataLayer = window.dataLayer || [];

    value = parseInt(`${value}`);

    const data = {
      Category: category,
      event: "load",
      Action: action,
      Label: label,
      Value: value,
      user_data: {
        em: await getIdentifier("smoy_email"),
        ph: await getIdentifier("smoy_phone"),
        aid: await getIdentifier("smoy_aid"),
        emp: await getIdentifier("smoy_email_plain"),
        php: await getIdentifier("smoy_phone_plain"),
        ifl: await getIdentifier("smoy_ifl"),
        hcm: await getIdentifier("smoy_hcm"),
        smoy_lead_score: await getIdentifier("smoy_lead_score"),
        first_name: localStorage.getItem("smoy_fn") || undefined,
        last_name: localStorage.getItem("smoy_ln") || undefined,
        age: localStorage.getItem("smoy_age") || undefined,
      },
      ...(extraParams || {}),
    };

    window.dataLayer.push(data);
  } catch (err) {
    // logJSError({
    //   err,
    //   description: "pushToDataLayer",
    // });
  }
};

const logJSError = async ({
  err,
  description = "",
}) => {
  try {
    pushToDataLayer({
      action: "error",
      label: `${getDomain()} JS error: ${
        err.toString() || "err.toString() not defined"
      }`,
    });

    const url = "https://api.summarumapps.fi/api/logging/errors";
    return fetch(url, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        site: getDomain(),
        error_json_stringified: `${
          JSON.stringify(err, Object.getOwnPropertyNames(err)) || "err.toString() not defined"
        }`,
        additional_information: description,
      }),
    });
  } catch (err) {
    console.log(err);
  }
};

const getIPv4Address = async () => {
  try {
    const res = await (
      await fetch(
        "https://ip.kreditum.ee/9042f243-1145-4708-b60a-b65c6878bdb4.php"
      )
    ).json();

    if (res.success && res.data && res.data !== "") {
      return res.data;
    }

    return "";
  } catch (err) {
    return "";
  }
};

const isEmailDeliverable = async (email) => {
  try {
    const emailValidationRes = await (
      await fetch(API_URL, {
        method: "POST",
        body: JSON.stringify({
          ive: 1,
          email,
        }),
      })
    ).json();

    if (!!emailValidationRes && !emailValidationRes.valid) {
      return false;
    }

    return true;
  } catch (err) {
    logJSError({ err, description: "ied" });
    return true;
  }
};

function scrollToDiv(selector, offset = 66) {
  try {
    const element = document.querySelector(selector);

    if (element) {
      const topPosition =
        element.getBoundingClientRect().top + window.pageYOffset;

      window.scrollTo({
        top: topPosition - offset,
        behavior: "smooth",
      });
    } else {
      console.error("Element not found with the selector:", selector);
    }
  } catch (err) {
    logJSError({
      err,
      description: "scrollToDiv",
    });
  }
}

async function sha256(message) {
  try {
    if (!message || !window.crypto) {
      return "";
    }

    const msgBuffer = new TextEncoder().encode(message);
    const hashBuffer = await crypto.subtle.digest("SHA-256", msgBuffer);
    const hashArray = Array.from(new Uint8Array(hashBuffer));
    const hashHex = hashArray
      .map((b) => b.toString(16).padStart(2, "0"))
      .join("");
    return hashHex;
  } catch (err) {
    console.log(err);
    logJSError({ err, description: "sha256" });
    return "";
  }
}

const getClientId = () => {
  try {
    let cookieValue = document.cookie.split('; ').find((row) => row.startsWith('_ga='));
    if (cookieValue) {
      cookieValue = cookieValue.split('=')[1];
      const parsedValue = cookieValue.split('.').slice(2).join('.'); // e.g. GA1.2.123456789.123456789 -> 123456789.123456789
      if (parsedValue) return parsedValue;
    }

    if (window.gaGlobal && window.gaGlobal.vid) {
      return window.gaGlobal.vid;
    }

    if (window[window.GoogleAnalyticsObject]) {
      let _ga = window[window.GoogleAnalyticsObject];
      return _ga.getAll()[0].get('clientId');
    }
  } catch (error) {
    console.error(error);
  }

  return 'private';
};

const sleepMs = (ms) =>
  new Promise((resolve) => setTimeout(resolve, ms));

const mapFormDataToPayload = async ({
  data,
  formStatus,
}) => {
  const payload = {
    site: getDomain(),
    email: data.email,
    loan_amount: Number(data.loanAmount),
    loan_term_months: Number(data.loanTermMonths || 12),
    form_status: formStatus,
    marketing_allowed: data.marketingAccepted,
    event_source_url: window.location.href,
    event_source_url_timestamp: getCurrentTimeAsDateTime(),
    leadgid_click_id: (() => {
      try {
        const val = getCookie("leadgid_click_id");
        if (val) {
          return val;
        }

        return "";
      } catch (err) {
        logJSError({
          err,
          description: "leadgid_click_id",
        });
        return "";
      }
    })(),
    leadgid_click_timestamp: (() => {
      try {
        const val = getCookie("leadgid_click_timestamp");
        if (val) {
          return val;
        }

        return "";
      } catch (err) {
        logJSError({
          err,
          description: "leadgid_click_timestamp",
        });
        return "";
      }
    })(),
    client_id: (() => {
      try {
        return getClientId();
      } catch (err) {
        logJSError({
          err,
          description: "client_id",
        });
        return "private";
      }
    })(),
    gbraid: (() => {
      try {
        const val = getCookie("summarum_gbraid");
        if (val) {
          return val;
        }

        return "";
      } catch (err) {
        logJSError({
          err,
          description: "gbraid",
        });
        return "";
      }
    })(),
    gbraid_timestamp: (() => {
      try {
        const val = getCookie("summarum_gbraid_timestamp");
        if (val) {
          return val;
        }
        return "";
      } catch (err) {
        logJSError({
          err,
          description: "gbraid_timestamp",
        });
        return "";
      }
    })(),
    wbraid: (() => {
      try {
        const val = getCookie("summarum_wbraid");
        if (val) {
          return val;
        }

        return "";
      } catch (err) {
        logJSError({
          err,
          description: "wbraid",
        });
        return "";
      }
    })(),
    wbraid_timestamp: (() => {
      try {
        const val = getCookie("summarum_wbraid_timestamp");
        if (val) {
          return val;
        }
        return "";
      } catch (err) {
        logJSError({
          err,
          description: "wbraid_timestamp",
        });
        return "";
      }
    })(),
    gclid: (() => {
      try {
        const val = getCookie("summarum_gclid");
        if (val) {
          return val;
        }

        return "";
      } catch (err) {
        logJSError({
          err,
          description: "gclid",
        });
        return "";
      }
    })(),
    gclid_timestamp: (() => {
      try {
        const val = getCookie("summarum_gclid_timestamp");
        if (val) {
          return val;
        }
        return "";
      } catch (err) {
        logJSError({
          err,
          description: "gclid_timestamp",
        });
        return "";
      }
    })(),
    fbc: (() => {
      try {
        const val = getCookie("summarum_fbc");
        if (val) {
          return val;
        }

        return "";
      } catch (err) {
        logJSError({
          err,
          description: "fbc",
        });
        return "";
      }
    })(),
    fbc_timestamp: (() => {
      try {
        const val = getCookie("summarum_fbc_timestamp");
        if (val) {
          return val;
        }
        return "";
      } catch (err) {
        logJSError({
          err,
          description: "fbc_timestamp",
        });
        return "";
      }
    })(),
    msclkid: (() => {
      try {
        const val = getCookie("summarum_msclkid");
        if (val) {
          return val;
        }

        return "";
      } catch (err) {
        logJSError({
          err,
          description: "msclkid",
        });
        return "";
      }
    })(),
    msclkid_timestamp: (() => {
      try {
        const val = getCookie("summarum_msclkid_timestamp");
        if (val) {
          return val;
        }
        return "";
      } catch (err) {
        logJSError({
          err,
          description: "msclkid_timestamp",
        });
        return "";
      }
    })(),
    pa_clickid: (() => {
      try {
        const val = getCookie("summarum_pa_clickid");
        if (val) {
          return val;
        }

        return "";
      } catch (err) {
        logJSError({
          err,
          description: "pa_clickid",
        });
        return "";
      }
    })(),
    pa_clickid_timestamp: (() => {
      try {
        const val = getCookie("summarum_pa_clickid_timestamp");
        if (val) {
          return val;
        }
        return "";
      } catch (err) {
        logJSError({
          err,
          description: "pa_clickid_timestamp",
        });
        return "";
      }
    })(),
    tblci: (() => {
      try {
        const val = getCookie("summarum_tblci");
        if (val) {
          return val;
        }

        return "";
      } catch (err) {
        logJSError({
          err,
          description: "tblci",
        });
        return "";
      }
    })(),
    tblci_timestamp: (() => {
      try {
        const val = getCookie("summarum_tblci_timestamp");
        if (val) {
          return val;
        }
        return "";
      } catch (err) {
        logJSError({
          err,
          description: "tblci_timestamp",
        });
        return "";
      }
    })(),
    ra_clickid: (() => {
      try {
        const val = getCookie("summarum_ra_clickid");
        if (val) {
          return val;
        }

        return "";
      } catch (err) {
        logJSError({
          err,
          description: "ra_clickid",
        });
        return "";
      }
    })(),
    ra_clickid_timestamp: (() => {
      try {
        const val = getCookie("summarum_ra_clickid_timestamp");
        if (val) {
          return val;
        }
        return "";
      } catch (err) {
        logJSError({
          err,
          description: "ra_clickid_timestamp",
        });
        return "";
      }
    })(),
    ttclid: (() => {
      try {
        const val = getCookie("summarum_ttclid");
        if (val) {
          return val;
        }

        return "";
      } catch (err) {
        logJSError({
          err,
          description: "ttclid",
        });
        return "";
      }
    })(),
    ttclid_timestamp: (() => {
      try {
        const val = getCookie("summarum_ttclid_timestamp");
        if (val) {
          return val;
        }
        return "";
      } catch (err) {
        logJSError({
          err,
          description: "ttclid_timestamp",
        });
        return "";
      }
    })(),
    organic_search_landing_page_url: (() => {
      try {
        const val = getCookie("summarum_organic_search_landing_page_url");
        if (val) {
          return val;
        }

        return "";
      } catch (err) {
        logJSError({
          err,
          description: "oslpu",
        });
        return "";
      }
    })(),
    organic_search_landing_page_url_timestamp: (() => {
      try {
        const val = getCookie("summarum_organic_search_landing_page_url_timestamp");
        if (val) {
          return val;
        }
        return "";
      } catch (err) {
        logJSError({
          err,
          description: "oslpu_timestamp",
        });
        return "";
      }
    })(),
  };

  return payload;
};

const updateDB = async ({
  input,
  formStatus,
}) => {
  try {
    const apiCall = await mapFormDataToPayload({
      data: input,
      formStatus,
    });

    const res = await (
      await fetch(API_URL, {
        method: "POST",
        body: JSON.stringify({
          applicants: 1,
          ...apiCall,
        }),
      })
    ).json();

    if (!res.id) {
      logJSError({
        err: new Error("No ID in response"),
        description: "updateDB: " + JSON.stringify(res),
      });

      return null;
    }

    await setIdentifier({
      identifier: "smoy_aid",
      value: `${res.id}`,
    });

    return res;
  } catch (err) {
    logJSError({
      err,
      description: "updateDB",
    });

    return null;
  }
};

/* Selectors
--------------------------------------------- */

const getTermsCheckbox = () =>
  document.querySelector(".flf2024-firstStep-terms");

const getMarketingCheckbox = () =>
  document.querySelector(
    ".flf2024-firstStep-marketingAllowed"
  );

const getloanTermMonthsInput = () =>
  document.querySelector("#flf2024-loanTermMonths");

const getloanTermMonthsSlider = () =>
  document.getElementById("loanTermMonthsSlider");

const getLoanAmountInput = () =>
  document.querySelector("#flf2024-loanAmount");

const getLoanAmountSlider = () =>
  document.getElementById("loanAmountSlider");

const getEmailInput = () =>
  document.querySelector(".flf2024-firstStep-email");

const getPhoneInput = () =>
  document.querySelector(".flf2024-firstStep-phone");

const getFirstNameInput = () =>
  document.querySelector(".flf2024-firstStep-firstName");

const getRootDivSelector = () => ".flf2024-root";
const getRootDiv = () =>
  document.querySelector(getRootDivSelector());

const get1stStepCta = () => 
  document.querySelector(".flf2024-firstStep-cta");

const get2ndStepCta = () =>
  document.querySelector(".flf2024-secondStep-cta");

const get1stStepDiv = () =>
  document.querySelector(".flf2024-1st-step");

const get2ndStepDiv = () =>
  document.querySelector(".flf2024-2nd-step");

const getFullFormDiv = () =>
  document.querySelector(".flf2024-full-form");

/* Loaders
--------------------------------------------- */

const setLoanAmountValue = ({
  value,
  updateSlider = false,
}) => {
  const loanAmountInput = getLoanAmountInput();
  const loanAmountSlider =
    document.querySelector("#loanAmountSlider");
  if (!loanAmountSlider || !loanAmountInput) {
    return;
  }

  if (getDomain() === "credum.ph") {
    if (value < 1000) {
      value = 1000;
    } else if (value > 50000) {
      value = 50000;
    }
  } else if (getDomain() === "credum.co") {
    if (value < 100000) {
      value = 100000;
    } else if (value > 10000000) {
      value = 10000000;
    }
  } else if (getDomain() === "credum.mx") {
    if (value < 1000) {
      value = 1000;
    } else if (value > 150000) {
      value = 150000;
    }
  } else if (getDomain() === "creditum.co.za") {
    if (value < 500) {
      value = 500;
    } else if (value > 350000) {
      value = 350000;
    }
  } else if (getDomain() === "credum.pl") {
    if (value < 500) {
      value = 500;
    } else if (value > 150000) {
      value = 150000;
    }
  } else if (getDomain() === "credum.ro") {
    if (value < 100) {
      value = 100;
    } else if (value > 20000) {
      value = 20000;
    }
  } else if (getDomain() === "crediteus.dk") {
    if (value < 5000) {
      value = 5000;
    } else if (value > 400000) {
      value = 400000;
    }
  } else if (getDomain() === "credum.kz") {
    if (value < 50000) {
      value = 50000;
    } else if (value > 10000000) {
      value = 10000000;
    }
  } else {
    if (value < 1000) {
      value = 1000;
    } else if (value > 50000) {
      value = 50000;
    }
  }

  if (loanAmountInput) {
    if (getDomain() === "credum.co") {
      // add helper for 1000s
      loanAmountInput.value = value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    } else if (getDomain() === "credum.kz") {
      loanAmountInput.value = value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
    } else {
      loanAmountInput.value = value.toString();
    }
  }

  if (updateSlider) {
    if (loanAmountSlider) {
      const step = getNearestLoanAmountSliderStepWithValue(value);
      loanAmountSlider.value = step.toString();
    }
  }
};

const loanAmountSteps = () => {
  const values = [];
  if (getDomain() === "credum.ph") {
    for (let i = 1000; i <= 50000; i += 1000) {
      values.push(i);
    }
  } else if (getDomain() === "credum.co") {
    for (let i = 100000; i <= 10000000; i += 100000) {
      values.push(i);
    }
  } else if (getDomain() === "credum.mx") {
    for (let i = 1000; i <= 150000; i += 1000) {
      values.push(i);
    }
  } else if (getDomain() === "creditum.co.za") {
    for (let i = 500; i <= 350000; i += 500) {
      values.push(i);
    }
  } else if (getDomain() === "credum.pl") {
    for (let i = 500; i <= 150000; i += 500) {
      values.push(i);
    }
  } else if (getDomain() === "credum.ro") {
    for (let i = 100; i <= 20000; i += 100) {
      values.push(i);
    }
  } else if (getDomain() === "crediteus.dk") {
    for (let i = 5000; i <= 400000; i += 5000) {
      values.push(i);
    }
  } else if (getDomain() === "credum.kz") {
    for (let i = 50000; i <= 10000000; i += 50000) {
      values.push(i);
    }
  } else {
    for (let i = 1000; i <= 50000; i += 1000) {
      values.push(i);
    }
  }

  return values;
}

const getLoanAmountSliderValueWithStep = (step) => {
  step = step - 1;

  const values = loanAmountSteps();

  return values[step];
};

const getNearestLoanAmountSliderStepWithValue = (value) => {
  const values = loanAmountSteps();

  const closest = values.reduce((prev, curr) => {
    return Math.abs(curr - value) < Math.abs(prev - value) ? curr : prev;
  });

  return values.indexOf(closest) + 1;
};

const loadLoanAmountSelector = () => {
  const loanAmountSlider = getLoanAmountSlider();
  const loanAmountSliderEventListener = (event) => {
    const target = event.target;
    let value = target.value;
    if (!value) {
      value = "1000";
    }
    const match = getLoanAmountSliderValueWithStep(Number(target.value));
    setLoanAmountValue({ value: match, updateSlider: false });
  };

  loanAmountSlider.addEventListener("input", loanAmountSliderEventListener);

  const loanAmountInput = document.querySelector(
    "#flf2024-loanAmount"
  );
  const loanAmountInputEventListener = (event) => {
    event.preventDefault();
    const target = event.target;
    let value = parseInt(target.value);
    
    if (isNaN(value)) {
      if (getDomain() === "credum.ph") {
        value = 1000;
      } else if (getDomain() === "credum.co") {
        value = 100000;
      } else if (getDomain() === "credum.mx") {
        value = 1000;
      } else if (getDomain() === "creditum.co.za") {
        value = 500;
      } else if (getDomain() === "credum.pl") {
        value = 500;
      } else if (getDomain() === "credum.ro") {
        value = 100;
      } else if (getDomain() === "crediteus.dk") {
        value = 5000;
      } else if (getDomain() === "credum.kz") {
        value = 50000;
      } else {
        value = 1000;
      }
    }
  
    setLoanAmountValue({ value, updateSlider: true });
  };

  loanAmountInput.addEventListener("change", loanAmountInputEventListener);

  const onlyAllowNumbersInLoanAmountInputListener = (e) => {
    const el = e.target;
    el.value = el.value.replace(/[^0-9]/g, "");
  };
  loanAmountInput.addEventListener("input", onlyAllowNumbersInLoanAmountInputListener);
};

const setloanTermMonthsValue = ({
  value,
  updateSlider = false,
}) => {
  const loanTermMonthsInput = document.querySelector(
    "#flf2024-loanTermMonths"
  );
  const loanTermMonthsSlider = document.querySelector(
    "#loanTermMonthsSlider"
  );
  if (!loanTermMonthsSlider || !loanTermMonthsInput) {
    return;
  }

  value = Math.round(value);

  if (getDomain() === "credum.co" || getDomain() === "credum.mx") {
    if (value < 2) {
      value = 2;
    } else if (value > 36) {
      value = 36;
    }
  } else {
    if (value < 1) {
      value = 1;
    } else if (value > 36) {
      value = 36;
    }
  }

  if (loanTermMonthsInput) {
    loanTermMonthsInput.value = value.toString();
  }

  if (updateSlider) {
    if (loanTermMonthsSlider) {
      loanTermMonthsSlider.value = value.toString();
    }
  }

  const loanTermMonthsValueLabelText = document.querySelector(
    ".flf2024-loanTermMonthsValueLabelText"
  );
  if (getDomain() === "credum.ph") {
    loanTermMonthsValueLabelText.textContent = value === 1 ? "month" : "months";
  } else if (getDomain() === "credum.co" || getDomain() === "credum.mx") {
    loanTermMonthsValueLabelText.textContent = value === 1 ? "mes" : "meses";
  } else if (getDomain() === "creditum.co.za") {
    loanTermMonthsValueLabelText.textContent = value === 1 ? "month" : "months";
  } else if (getDomain() === "credum.pl") {
    loanTermMonthsValueLabelText.textContent = value === 1 ? "miesiąc" : "miesięcy";
  } else if (getDomain() === "credum.ro") {
    loanTermMonthsValueLabelText.textContent = value === 1 ? "lună" : "luni";
  } else if (getDomain() === "crediteus.dk") {
    loanTermMonthsValueLabelText.textContent = value === 1 ? "måned" : "måneder";
  } else if (getDomain() === "credum.kz") {
    loanTermMonthsValueLabelText.textContent = value === 1 ? "месяц" : "месяцев";
  } else {
    loanTermMonthsValueLabelText.textContent = value === 1 ? "month" : "months";
  }
};

const loadLoanTermMonthsSelector = () => {
  const loanTermMonthsInput = getloanTermMonthsInput();
  const loanTermMonthsSelectorEventListener = (event) => {
    const target = event.target;
    let value = target.value;

    if (!value) {
      value = "1";
    }
    setloanTermMonthsValue({
      value: Number(value),
      updateSlider: true,
    });
  };
  loanTermMonthsInput.addEventListener(
    "change",
    loanTermMonthsSelectorEventListener
  );

  const loanTermMonthsSlider = getloanTermMonthsSlider();
  const loanTermMonthsSliderEventListener = (event) => {
    event.preventDefault();
    const target = event.target;
    setloanTermMonthsValue({
      value: Number(target.value),
      updateSlider: false,
    });
  };
  loanTermMonthsSlider.addEventListener(
    "input",
    loanTermMonthsSliderEventListener
  );
};

const loadMonthlyPaymentCalculator = () => {
  const amountInput = getLoanAmountInput();
  const loanTermMonthsInput = getloanTermMonthsInput();
  const amountSlider = getLoanAmountSlider();
  const loanTermMonthsSlider = getloanTermMonthsSlider();

  const updateMonthlyPayment = () => {
    const monthlyPaymentElement = document.querySelector(
      ".flf2024-monthlyPaymentElement"
    );
    const amount = Number(amountInput.value.replaceAll(",", "").replaceAll(".", ""));
    const termMonths = Number(loanTermMonthsInput.value);

    const yearlyInterestRate = getDomain() === "credum.co" || getDomain() === "credum.mx"
      ? 0.2
      : 0.099;

    const monthlyPayment = getMonthlyPayment({
      loanAmount: amount,
      paybackTimeInYears: termMonths / 12,
      yearlyInterestRate,
      openingCost: 0,
      monthlyAdditionalFee: 0,
    });

    if (getDomain() === "credum.ph") {
      monthlyPaymentElement.textContent = `${monthlyPayment} ₱`;
    } else if (getDomain() === "credum.co" || getDomain() === "credum.mx") {
      const p = `${monthlyPayment}`;
      monthlyPaymentElement.textContent = `$ ${p.replace(/\B(?=(\d{3})+(?!\d))/g, ",")}`;
    } else if (getDomain() === "creditum.co.za") {
      const p = `${monthlyPayment}`;
      monthlyPaymentElement.textContent = `R ${p.replace(/\B(?=(\d{3})+(?!\d))/g, ",")}`;
    } else if (getDomain() === "credum.pl") {
      const p = `${monthlyPayment}`;
      monthlyPaymentElement.textContent = `${monthlyPayment} zł`;
    } else if (getDomain() === "credum.ro") {
      const p = `${monthlyPayment}`;
      monthlyPaymentElement.textContent = `${monthlyPayment} Lei`;
    } else if (getDomain() === "crediteus.dk") {
      monthlyPaymentElement.textContent = `${monthlyPayment} kr`;
    } else if (getDomain() === "credum.kz") {
      monthlyPaymentElement.textContent = `${monthlyPayment} ₸`;
    } else {
      monthlyPaymentElement.textContent = `${monthlyPayment}`;
    }
  };

  amountInput.addEventListener("change", updateMonthlyPayment);
  loanTermMonthsInput.addEventListener("change", updateMonthlyPayment);
  amountSlider.addEventListener("input", updateMonthlyPayment);
  loanTermMonthsSlider.addEventListener("input", updateMonthlyPayment);
  if (getDomain() === "creditum.co.za") {
    (document.querySelector('.flf2024-amount-minus')).addEventListener('click', () => {
      setTimeout(() => {
        updateMonthlyPayment();
      }, 100);
    });
    (document.querySelector('.flf2024-amount-plus')).addEventListener('click', () => {
      setTimeout(() => {
        updateMonthlyPayment();
      }, 100);
    });
  }

  // Initial update
  updateMonthlyPayment();
};

const getMonthlyPayment = ({
  loanAmount,
  paybackTimeInYears,
  yearlyInterestRate, // e.g. 0.045
  openingCost,
  monthlyAdditionalFee,
}) => {
  const p = loanAmount + openingCost;
  const i = yearlyInterestRate / 12;
  const n = paybackTimeInYears * 12;

  let payment = (p * i * Math.pow(1 + i, n)) / (Math.pow(1 + i, n) - 1);
  payment = payment + monthlyAdditionalFee;

  return Math.round(payment);
};

const touchedListener = (e) => {
  const el = e.target;
  el.parentElement.classList.add("flf2024-touched");
};

const minMaxLength = ({
  el,
  min,
  max,
}) => {
  if (el.value.length < min || el.value.length > max) {
    el.parentElement.classList.add("flf2024-invalid");
  } else {
    el.parentElement.classList.remove("flf2024-invalid");
  }
};

const isChecked = (el) => {
  if (!el.checked) {
    el.parentElement.classList.add("flf2024-invalid");
  } else {
    el.parentElement.classList.remove("flf2024-invalid");
  }
};

const loadEmailValidation = () => {
  const emailInput = document.querySelector(
    ".flf2024-firstStep-email"
  );
  emailInput.addEventListener("blur", touchedListener);

  const emailValidationFn = () => {
    const passesSimpleRegex = EMAIL_REGEX.test(emailInput.value);
    if (!emailInput.value || !passesSimpleRegex) {
      emailInput.parentElement.classList.add("flf2024-invalid");
    } else {
      emailInput.parentElement.classList.remove("flf2024-invalid");
    }
  };
  emailInput.addEventListener("input", emailValidationFn);
  emailInput.addEventListener("change", emailValidationFn);
};

const loadPhoneValidation = () => {
  const phoneInput = document.querySelector(
    ".flf2024-firstStep-phone"
  );
  phoneInput.addEventListener("blur", touchedListener);

  const phoneValidationFn = () => {
    const passesSimpleRegex = PHONE_REGEX.test(phoneInput.value);
    if (!phoneInput.value || !passesSimpleRegex) {
      phoneInput.parentElement.classList.add("flf2024-invalid");
    } else {
      phoneInput.parentElement.classList.remove("flf2024-invalid");
    }
  };
  phoneInput.addEventListener("input", phoneValidationFn);
  phoneInput.addEventListener("change", phoneValidationFn);
};

const loadFirstNameValidation = () => {
  const firstNameInput = document.querySelector(
    ".flf2024-firstStep-firstName"
  );
  firstNameInput.addEventListener("blur", touchedListener);

  const firstNameValidationFn = () => {
    minMaxLength({ el: firstNameInput, min: 2, max: 99 });
  };
  firstNameInput.addEventListener("input", firstNameValidationFn);
  firstNameInput.addEventListener("change", firstNameValidationFn);
};

const loadLastNameValidation = () => {
  const lastNameInput = document.querySelector(
    ".flf2024-firstStep-lastName"
  );
  lastNameInput.addEventListener("blur", touchedListener);

  const firstNameValidationFn = () => {
    minMaxLength({ el: lastNameInput, min: 2, max: 99 });
  };
  lastNameInput.addEventListener("input", firstNameValidationFn);
  lastNameInput.addEventListener("change", firstNameValidationFn);
};

const loadSsnValidation = () => {
  const ssnInput = document.querySelector(
    ".flf2024-firstStep-ssn"
  );
  ssnInput.addEventListener("blur", touchedListener);

  const ssnValidationFn = () => {
    const passesSimpleRegex = SSN_REGEX.test(ssnInput.value);
    if (!ssnInput.value || !passesSimpleRegex) {
      ssnInput.parentElement.classList.add("flf2024-invalid");
    } else {
      ssnInput.parentElement.classList.remove("flf2024-invalid");
    }
  };
  ssnInput.addEventListener("input", ssnValidationFn);
  ssnInput.addEventListener("change", ssnValidationFn);
};

const loadLoanPurposeValidation = () => {
  const loanPurposeSelect = document.querySelector(
    ".flf2024-firstStep-loanPurpose"
  );
  loanPurposeSelect.addEventListener("blur", touchedListener);

  const loanPurposeValidationFn = () => {
    if (!loanPurposeSelect.value) {
      loanPurposeSelect.parentElement.classList.add("flf2024-invalid");
    } else {
      loanPurposeSelect.parentElement.classList.remove("flf2024-invalid");
    }
  };
  loanPurposeSelect.addEventListener("change", loanPurposeValidationFn);
};

const loadTermsValidation = () => {
  const termsCheckbox = document.querySelector(
    ".flf2024-firstStep-terms"
  );
  termsCheckbox.addEventListener("blur", touchedListener);
  const termsValidationFn = () => {
    isChecked(termsCheckbox);
  };
  termsCheckbox.addEventListener("change", termsValidationFn);
};

const loadValidations = () => {
  loadEmailValidation();
  // loadPhoneValidation();
  // loadFirstNameValidation();
  // loadLastNameValidation();
  // loadSsnValidation();
  // loadLoanPurposeValidation();
  loadTermsValidation();
};

let preventDisableRemoval = false;
const withLoading = (action = async () => null) => async () => {
  let finished = false;
  // const submitBtn = get2ndStepCta();
  const submitBtn = get1stStepCta();

  const originalText = submitBtn.textContent;
  if (getDomain() === "credum.co" || getDomain() === "credum.mx") {
    submitBtn.textContent = "Procesando...";
  } else {
    submitBtn.textContent = "Processing...";
  }

  setTimeout(() => {
    if (finished) {
      return;
    }

    if (getDomain() === "credum.co" || getDomain() === "credum.mx") {
      submitBtn.textContent = "Un momento más...";
    } else {
      submitBtn.textContent = "One more moment...";
    }
  }, 4000);
  submitBtn.classList.add("flf2024-loading");
  submitBtn.disabled = true;

  const spinner = document.querySelector<HTMLDivElement>(".flf2024-spinner");
  const nonSpinnerContent = document.querySelector<HTMLDivElement>(
    ".flf2024-nonSpinnerContent"
  );

  if (spinner && nonSpinnerContent) {
    spinner.style.display = "inline-block";
    nonSpinnerContent.style.display = "none";
  }

  await action();
  finished = true;

  // For cases where a redirect has been initiated, we don't want to remove the loading state
  if (preventDisableRemoval) {
    return;
  }

  submitBtn.textContent = originalText;
  submitBtn.classList.remove("flf2024-loading");
  submitBtn.disabled = false;

  if (spinner && nonSpinnerContent) {
    spinner.style.display = "none";
    nonSpinnerContent.style.display = "block";
  }
};

const load1stStepForm = () => {
  loadLoanAmountSelector();
  if (
    getDomain() !== "creditum.co.za" &&
    getDomain() !== "credum.pl" &&
    getDomain() !== "credum.ro" &&
    getDomain() !== "crediteus.dk" &&
    getDomain() !== "credum.kz"
  ) {
    loadLoanTermMonthsSelector();
    loadMonthlyPaymentCalculator();
  }
  loadValidations();

  /**
   * Runs when the user clicks the initial "Hae lainatarjoukset" button
   */
  const firstStepCtaEventListener = async () => {
    const d = getDomain();

    await withLoading(async () => {
      try {
        const amount = getLoanAmountInput().value.replaceAll(",", "").replaceAll(".", "").replaceAll(" ", "");
        const term = getloanTermMonthsInput()?.value || "12";
        const email = getEmailInput().value;
        const terms = getTermsCheckbox().checked;
        const marketing = getMarketingCheckbox().checked;

        /**
         * Validation
         */
        
        const errors = [];
        if (!email) {
          errors.push(d === "credum.ph"
            ? "Email is required."
            : (d === "credum.co" || d === "credum.mx")
            ? "Se requiere correo electrónico."
            : (d === "creditum.co.za")
            ? "Email is required."
            : (d === "credum.pl")
            ? "Adres e-mail jest wymagany."
            : (d === "credum.ro")
            ? "Adresa de email este obligatorie."
            : (d === "crediteus.dk")
            ? "E-mailadresse er påkrævet."
            : (d === "credum.kz")
            ? "Требуется адрес электронной почты."
            : "Email is required."
          )
        } else if (
          !EMAIL_REGEX.test(email) ||
          !(await isEmailDeliverable(email))
        ) {
          pushToDataLayer({ action: 'email-validation', label: 'not-deliverable' });
          errors.push(d === "credum.ph"
            ? "The email address is invalid."
            : (d === "credum.co" || d === "credum.mx")
            ? "La dirección de correo electrónico no es válida."
            : (d === "creditum.co.za")
            ? "The email address is invalid."
            : (d === "credum.pl")
            ? "Adres e-mail jest nieprawidłowy."
            : (d === "credum.ro")
            ? "Adresa de email este invalidă."
            : (d === "crediteus.dk")
            ? "E-mailadressen er ugyldig."
            : (d === "credum.kz")
            ? "Адрес электронной почты недействителен."
            : "The email address is invalid."
          )
        }

        const amountNum = parseInt(amount);
        if (d === "credum.ph") {
          if (amountNum < 1000 || amountNum > 50000) {
            errors.push("The loan amount must be between 1000 and 50000.");
          }
        }
        if ((d === "credum.co")) {
          if (amountNum < 100000 || amountNum > 10000000) {
            errors.push("El monto del préstamo debe estar entre 100.000 y 10.000.000.");
          }
        }
        if ((d === "credum.mx")) {
          if (amountNum < 1000 || amountNum > 150000) {
            errors.push("El monto del préstamo debe estar entre 1000 y 150000.");
          }
        }
        if ((d === "creditum.co.za")) {
          if (amountNum < 500 || amountNum > 350000) {
            errors.push("The loan amount must be between 500 and 350000.");
          }
        }
        if ((d === "credum.pl")) {
          if (amountNum < 500 || amountNum > 150000) {
            errors.push("Kwota pożyczki musi być między 500 a 150000 zł.");
          }
        }
        if ((d === "credum.ro")) {
          if (amountNum < 100 || amountNum > 20000) {
            errors.push("Suma împrumutului trebuie să fie între 100 și 20000 lei.");
          }
        }
        if ((d === "crediteus.dk")) {
          if (amountNum < 5000 || amountNum > 400000) {
            errors.push("Lånebeløbet skal være mellem 5.000 og 400.000 kr.");
          }
        }
        if ((d === "credum.kz")) {
          if (amountNum < 50000 || amountNum > 10000000) {
            errors.push("Сумма займа должна быть от 50 000 до 10 000 000 тенге.");
          }
        }

        const termNum = parseInt(term);
        if (d === "credum.ph") {
          if (termNum < 1 || termNum > 36) {
            errors.push("The loan term must be between 1 and 36 months.");
          }
        }
        if ((d === "credum.co" || d === "credum.mx")) {
          if (termNum < 2 || termNum > 36) {
            errors.push("El plazo del préstamo debe estar entre 2 y 36 meses.");
          }
        }
        if ((d === "creditum.co.za")) {
          if (termNum < 1 || termNum > 36) {
            errors.push("The loan term must be between 1 and 36 months.");
          }
        }
        if ((d === "credum.pl")) {
          if (termNum < 1 || termNum > 36) {
            errors.push("Okres spłaty musi wynosić od 1 do 60 miesięcy.");
          }
        }
        if ((d === "credum.ro")) {
          if (termNum < 1 || termNum > 36) {
            errors.push("Perioada împrumutului trebuie să fie între 1 și 36 de luni.");
          }
        }
        if ((d === "crediteus.dk")) {
          if (termNum < 1 || termNum > 15) {
            errors.push("Låneperioden skal være mellem 1 og 15 år.");
          }
        }

        if (!terms) {
          errors.push(d === "credum.ph"
            ? "Terms and conditions is a required field."
            : (d === "credum.co" || d === "credum.mx")
            ? "Los términos y condiciones son un campo obligatorio."
            : (d === "creditum.co.za")
            ? "Terms and conditions is a required field."
            : (d === "credum.pl")
            ? "Akceptacja regulaminu jest wymagana."
            : (d === "credum.ro")
            ? "Termenii și condițiile sunt obligatorii."
            : (d === "crediteus.dk")
            ? "Vilkår og betingelser er et obligatorisk felt."
            : (d === "credum.kz")
            ? "Необходимо принять условия и положения."
            : "Terms and conditions is a required field."
          )
        }

        if (errors.length) {
          alert(errors.join(" "));
          return;
        }

        pushToDataLayer({ action: 'email-validation', label: 'deliverable' });

        /**
         * Update DB
         */

        const [applicantsRes, isFreshLeadResult] = await Promise.all([
          updateDB({
            input: {
              email,
              loanAmount: amountNum,
              loanTermMonths: termNum,
              marketingAccepted: marketing,
            },
            formStatus: (getDomain() || "").includes("crediteus.dk")
              ? "sent-to-salus-iframe"
              : "redirected-to-affiliate-links-from-front-page",
          }),
          isFreshLead({
            email,
            phone: "",
          })
        ]);
        await setIdentifier({
          identifier: "smoy_ifl",
          value: isFreshLeadResult ? "1" : "0",
        });

        await setIdentifier({
          identifier: "smoy_email",
          value: await sha256(email),
        });
        await setIdentifier({
          identifier: "smoy_email_plain",
          value: email.toLowerCase(),
        });

        const applicantId = applicantsRes.id ? applicantsRes.id : "";
        if (applicantId) {
          await setIdentifier({
            identifier: "smoy_aid",
            value: applicantId,
          });
        }

        if ((getDomain() || "").includes("creditum.co.za")) {
          const pubidsub1 = "creditum.co.za";
          const pubidsub3 = getClientId();
          const pubidsub5 = (() => {
            try {
              const mostRecentUTMMedium = getCookie('most_recent_utm_medium');
              if (mostRecentUTMMedium === 'email') {
                return 'email';
              } else if (mostRecentUTMMedium === 'organic') {
                return 'organic';
              } else if (mostRecentUTMMedium === 'sms') {
                return 'sms';
              } else {
                return 'paid';
              }
            } catch (err) {
              return "other";
            }
          })();

          pushToDataLayer({ action: "sent-to", label: "salusZA" });
          pushToDataLayer({ action: "initiate-full-form", label: "creditum.co.za" });

          const platformName = getCookie("summarum_pfn");
          const campaignId = getCookie("summarum_cid");
          const adGroupId = getCookie("summarum_adgid");

          let redirUrl = `/application-form/?pubid_reference=${applicantId}&pubidsub1=${pubidsub1}&pubidsub3=${pubidsub3}&prefill[email]=${email}&prefill[loan_amount]=${amountNum}`;
          if (platformName) {
            redirUrl += `&pubidsub2=${platformName}`;
          }
          if (campaignId) {
            redirUrl += `&pubidsub4=${campaignId}`;
          }
          if (adGroupId) {
            redirUrl += `&pubidsub5=${adGroupId}`;
          }
          window.location.href = redirUrl;
        } else if ((getDomain() || "").includes("crediteus.dk")) {
          pushToDataLayer({ action: "submit", label: "1" });
          pushToDataLayer({ action: "redirected", label: "salusDK" });

          const salusRes = await (
            await fetch(API_URL, {
              method: "POST",
              body: JSON.stringify({
                dkcu: 1,
                email,
                site: "crediteus.dk",
                cui: Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15)
              }),
            })
          ).json();

          if (salusRes?.c !== "pass") {
            /**
             * Create PreApplication
             */
            const paRes = await (
              await fetch(API_URL, {
                method: "POST",
                body: JSON.stringify({
                  cpa: 1,
                  applicantId,
                  salusScore: "N/A",
                  freshnessScore: "0-0",
                  sentToPartner: "redirected-to-affiliate-links-from-front-page",
                  partnerPosition: 1,
                  hasCoApplicant: false,
                  site: getDomain(),
                  age: 99,
                  gender: "N/A",
                  loanPurpose: "N/A",
                  appliedAmount: amountNum,
                  appliedLoanTermYears: Math.round(termNum / 12) || 1,
                  ssn: "N/A",
                }),
              })
            ).json();
            if (paRes.id) {
              await setIdentifier({
                identifier: "smoy_paid",
                value: paRes.id,
              });
            }
  
            /**
             * Redirect to affiliate links page
             */
            preventDisableRemoval = true;
            setTimeout(async () => {
              window.location.href = await getRedirectUrl({
                preApplicationId: paRes.id || "",
              });
            }, 500);
            return;
          }

          /**
           * Create PreApplication
           */
          const paRes = await (
            await fetch(API_URL, {
              method: "POST",
              body: JSON.stringify({
                cpa: 1,
                applicantId,
                salusScore: "N/A",
                freshnessScore: "0-0",
                sentToPartner: "salusDK",
                partnerPosition: 1,
                hasCoApplicant: false,
                site: getDomain(),
                age: 99,
                gender: "N/A",
                loanPurpose: "N/A",
                appliedAmount: amountNum,
                appliedLoanTermYears: Math.round(termNum / 12) || 1,
                ssn: "N/A",
              }),
            })
          ).json();
          if (paRes.id) {
            await setIdentifier({
              identifier: "smoy_paid",
              value: paRes.id,
            });
          }

          let url = `/ansoegningen/`;
          url += `?loan_amount=${(getLoanAmountInput() || {value: ""}).value}`;
          url += `&pubid_reference=paId:${paRes.id}`;
          url += `&pubidsub1=crediteus.dk`;
          url += `&pubidsub3=${getClientId()}`;
          window.sessionStorage.setItem("email", email);

          window.location.href = url;
        } else {
          /**
           * Create PreApplication
           */
          const paRes = await (
            await fetch(API_URL, {
              method: "POST",
              body: JSON.stringify({
                cpa: 1,
                applicantId,
                salusScore: "N/A",
                freshnessScore: "0-0",
                sentToPartner: "redirected-to-affiliate-links-from-front-page",
                partnerPosition: 1,
                hasCoApplicant: false, // Not supported in this form plugin
                site: getDomain(),
                age: 99,
                gender: "N/A",
                loanPurpose: "N/A",
                appliedAmount: amountNum,
                appliedLoanTermYears: Math.round(termNum / 12) || 1,
                ssn: "N/A",
              }),
            })
          ).json();
          if (paRes.id) {
            await setIdentifier({
              identifier: "smoy_paid",
              value: paRes.id,
            });
          }
  
          /**
           * Redirect to affiliate links page
           */
          preventDisableRemoval = true;
          setTimeout(async () => {
            window.location.href = await getRedirectUrl({
              preApplicationId: paRes.id || "",
            });
          }, 500);
        }
      } catch (err) {
        logJSError({
          err,
          description: "firstStepCtaEventListener",
        });
        alert(JSON.stringify(err, Object.getOwnPropertyNames(err)));
        alert(
          d === "credum.ph"
            ? "Something went wrong. Please refresh the browser window and try again."
            : (d === "credum.co" || d === "credum.mx")
            ? "Algo salió mal. Actualice la ventana del navegador e inténtelo de nuevo."  
            : (d === "creditum.co.za")
            ? "Something went wrong. Please refresh the browser window and try again."
            : (d === "credum.pl")
            ? "Coś poszło nie tak. Proszę odświeżyć stronę i spróbować ponownie."
            : (d === "credum.ro")
            ? "Ceva nu a funcționat corect. Vă rugăm să reîmprospătați pagina și să încercați din nou."
            : (d === "crediteus.dk")
            ? "Noget gik galt. Opdater browservinduet og prøv igen."
            : (d === "credum.kz")
            ? "Что-то пошло не так. Пожалуйста, обновите страницу и попробуйте еще раз."
            : "Something went wrong. Please refresh the browser window and try again."
        )
      }
    })();
  };

  (get1stStepCta()).addEventListener("click", firstStepCtaEventListener);

  if (getDomain() === "creditum.co.za") {
    const minusButton = document.querySelector('.flf2024-amount-minus');
    const plusButton = document.querySelector('.flf2024-amount-plus');
    
    if (minusButton && plusButton) {
      minusButton.addEventListener('click', () => updateZALoanAmount('decrease'));
      plusButton.addEventListener('click', () => updateZALoanAmount('increase'));
    }
  }
};

const updateZALoanAmount = (action) => {
  const loanAmountInput = getLoanAmountInput();
  const currentAmount = parseInt(loanAmountInput.value.replace(/[^0-9]/g, ''), 10);
  let newAmount;

  if (action === 'increase') {
    newAmount = Math.min(currentAmount + 500, 350000);
  } else {
    newAmount = Math.max(currentAmount - 500, 500);
  }

  setLoanAmountValue({ value: newAmount, updateSlider: true });
};

let loaded = false;
const euCookiebotSites = ["credum.pl", "credum.ro", "crediteus.dk"]; // load regular GTM and cookiebot setup in footer for these sites
function loadPixels() {
  if (euCookiebotSites.some((site) => (getDomain() || "").includes(site))) {
    return;
  }
  
  if (loaded) {
    return;
  }

  try {
    if ((getDomain() || "").includes("creditum.co.za")) {
      (function(w, d, s, l, i) {
        w[l] = w[l] || [];
        w[l].push({
          'gtm.start': new Date().getTime(),
          event: 'gtm.js'
        });
        var f = d.getElementsByTagName(s)[0],
          j = d.createElement(s),
          dl = l != 'dataLayer' ? '&l=' + l : '';
        j.async = true;
        j.src =
          'https://www.googletagmanager.com/gtm.js?id=' + i + dl;
        f.parentNode.insertBefore(j, f);
      })(window, document, 'script', 'dataLayer', 'GTM-M47BKXR');
    } else {
      // meta
      !function(f,b,e,v,n,t,s)
      {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
      n.callMethod.apply(n,arguments):n.queue.push(arguments)};
      if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
      n.queue=[];t=b.createElement(e);t.async=!0;
      t.src=v;s=b.getElementsByTagName(e)[0];
      s.parentNode.insertBefore(t,s)}(window, document,'script',
      'https://connect.facebook.net/en_US/fbevents.js');
      fbq('init', '895976512552097');
      fbq('track', 'PageView');

      // tt
      !function (w, d, t) {
        w.TiktokAnalyticsObject=t;var ttq=w[t]=w[t]||[];ttq.methods=["page","track","identify","instances","debug","on","off","once","ready","alias","group","enableCookie","disableCookie","holdConsent","revokeConsent","grantConsent"],ttq.setAndDefer=function(t,e){t[e]=function(){t.push([e].concat(Array.prototype.slice.call(arguments,0)))}};for(var i=0;i<ttq.methods.length;i++)ttq.setAndDefer(ttq,ttq.methods[i]);ttq.instance=function(t){for(
      var e=ttq._i[t]||[],n=0;n<ttq.methods.length;n++)ttq.setAndDefer(e,ttq.methods[n]);return e},ttq.load=function(e,n){var r="https://analytics.tiktok.com/i18n/pixel/events.js",o=n&&n.partner;ttq._i=ttq._i||{},ttq._i[e]=[],ttq._i[e]._u=r,ttq._t=ttq._t||{},ttq._t[e]=+new Date,ttq._o=ttq._o||{},ttq._o[e]=n||{};n=document.createElement("script")
      ;n.type="text/javascript",n.async=!0,n.src=r+"?sdkid="+e+"&lib="+t;e=document.getElementsByTagName("script")[0];e.parentNode.insertBefore(n,e)};
        ttq.load('CQJ6FCJC77U77M6NPAB0');
        ttq.page();
      }(window, document, 'ttq');
    }

    loaded = true;
  } catch (err) {}
}

/* Engage!
--------------------------------------------- */
if (document.querySelector(".flf2024-form")) {
  load1stStepForm();

  const termsCheckbox = getTermsCheckbox();
  const emailInput = getEmailInput();
  
  if (termsCheckbox) {
    termsCheckbox.addEventListener("click", loadPixels, { once: true });
  }
  if (emailInput) {
    emailInput.addEventListener("change", loadPixels, { once: true });
  }
} else if (document.querySelector(".bctpTable")) {
  loadPixels();
}
